/**
 * Book 页面公共配置
 * 所有品牌共享的文案和资源
 */

export const commonTexts = {
  completed: 'Completed',
  ongoing: 'Ongoing',
  catalogue: 'Catalogue',
  latestChapter: 'Latest chapter',
  readFirstChapter: 'Read the first chapter first',
  startReading: 'Start Reading',
  continueReading: 'Continue Reading',
  noChapters: 'No chapters',
  booksNotExist: 'Books don\'t exist.',
  loading: 'Loading...',
} as const
